<template>
  <div style="padding-bottom: 20px;background-color: #FFFFFF;">
    <div class="main" :style="'background: url('+searchInfos.picUrl+') no-repeat center;background-size:cover;'">
      <div style="width: 100%;height: 100%;background-color: rgba(0,0,0,0.2);">
        <!-- 图片频道，公共头部 -->
        <div class="pic-header">
          <div class="logo-login">
            <img src="../assets/img/pic-logo.png" alt="人民互联网电视-图片频道"><span class="logo-icon">图片</span>
            <div class="to-login">
              <a :href="webUrl+'/picRegister'">成为供稿人</a>  <!-- v-if="JSON.parse(user.user).cameramanAudit!=1" -->
              <a @click="login" href="javascript:;"><img src="../assets/img/pic-login2.png"></a>
            </div>
          </div>
          <div class="search">
            <div class="title">{{searchInfos.title}}</div>
            <div class="input"><input type="text" v-model="searchText" @keyup.enter="goSearch" placeholder="搜索精彩图片和视频" /><img @click="goSearch" src="../assets/img/search.png"></div>
            <div class="keywords">推荐：<span v-for="item in searchInfos.tags" @click="changeSearch(item)">{{item}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图片频道，公共导航 -->
    <div class="nav" ref="picNav" :class="{'isFixed' : isFixed}">
      <div class="nav-list">
        <span :class="$route.name=='pictureIndex'?'active':''" @click="clickNav('pictureIndex')">主页</span>
        <span :class="$route.name=='explore'?'active':''" @click="clickNav('explore')">探索</span>
        <span :class="$route.name=='special'?'active':''" @click="clickNav('special')">专题</span>
        <span :class="$route.name=='picStory'?'active':''" @click="clickNav('picStory')">图片故事</span>
        <span :class="$route.name=='fashion'?'active':''" @click="clickNav('fashion')">时尚</span>
        <span :class="$route.name=='travel'?'active':''" @click="clickNav('travel')">旅游</span>
        <span :class="$route.name=='originalPicture'?'active':''" @click="clickNav('originalPicture')">原创图库</span>
        <span :class="$route.name=='pictureLive'?'active':''" @click="clickNav('pictureLive')">图片直播</span>
        <span :class="$route.name=='photographers'?'active':''" @click="clickNav('photographers')">摄影师</span>
      </div>
    </div>
    <PopupLogin v-show='user.loginFlag'></PopupLogin>
  </div>
</template>

<script>
  import {webUrl,searchStyle} from "@/api";
  import { mapState, mapActions } from 'vuex'
  import PopupLogin from '@/components/PopupLogin.vue'

  export default {
    name: "picIndex",
    data() {
      return {
        webUrl,
        title:'',
        isFixed:false,
        offsetTop:'',
        searchInfos:'',
        searchText:''

      }
    },
    computed:{
      ...mapState([
        'user'
      ])
    },
    // watch: {
      // $route() {
        // this.columnId = this.$route.meta.queryId || this.$route.query.id.split('.')[0] || this.$route.query.id;
      // }
    // },
    components: {
      PopupLogin
    },
    created() {
      let route_title=this.$route.query.title;
      this.title=route_title?route_title:localStorage.getItem("title");

      searchStyle().then(res => {
        if (!res.code) {
          this.searchInfos=res.info;
        }
      });
    },
    mounted() {
      // console.log('导航距顶部距离'+this.$refs.picNav.offsetTop);
       window.addEventListener('scroll',this.initHeight);
        this.$nextTick( () => {
          this.offsetTop = this.$refs.picNav.offsetTop;
        });
    },
    methods: {
      ...mapActions(['POPUP_LOGIN']),
      login:function(){
        // console.log(this.user);
        if(this.user.token){
          let user_infos=JSON.parse(this.user.user);
          // console.log(user_infos);
          if(user_infos.cameramanId && user_infos.cameramanAudit==1){
            this.$router.push({name:'createAtlas'});
          }else{
            // this.$snotify.error('请认证摄影师！');
            // 进入普通用户个人中心，非摄影师
            this.$router.push({name:'commonPersonCenter'});
          }
        }else{
          this.POPUP_LOGIN(true);
        }
      },
      clickNav:function(e){
          this.$router.push({name: e, query: {routeName: e}});
      },
      initHeight:function(){
        // 导航吸顶效果
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          this.isFixed = scrollTop > this.offsetTop ? true : false;
      },
      goSearch:function(){
        this.$router.push({name: 'searchResult', query: {wd: this.searchText}});
      },
      changeSearch:function(e){
        this.searchText=e;
      }
    },
    metaInfo(){
      return {
        title:this.$route.meta.title+'-人民互联网电视'
      }
    }
  }
</script>

<style scoped="scoped" lang="less">
  .main{
    width: 100%;
    height: 228px;
    // background: url('../assets/img/pic-header-bg.png') no-repeat center;
    // background-size: cover;
    .pic-header{
      width: 1120px;
      height: auto;
      margin: 0 auto;
      .logo-login{
        height: 56px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img{
          display: block;
          width: 164px;
          height: 38px;
        }
        .logo-icon{
          display: inline-block;
          width: 40px;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #FFFFFF;
          text-align: center;
          background: #ED4D50;
          border-radius: 3px;
          margin-right: auto;
          margin-top: 8px;
          margin-left: 6px;
        }
        .to-login{
          font-size: 14px;
          font-weight: 500;
          display: flex;
          a{
            color: #FFFFFF;
          }
          img{
            width: 20px;
            height: 20px;
            margin-left: 30px;
            cursor: pointer;
          }
        }
      }
      .search{
        width: 486px;
        margin: 20px auto 0;
        .title{
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 24px;
        }
        .input{
          width: 100%;
          margin: 18px 0;
          position: relative;
          input{
            width: 100%;
            height: 44px;
            font-size: 14px;
            color: #7F7F7F;
            background: #FFFFFF;
            text-indent: 20px;
            border-radius: 5px;
            border: none;
            padding: 0;
          }
          img{
            display: block;
            width: 17px;
            height: 17px;
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            cursor: pointer;
          }
        }
        .keywords{
          font-size: 14px;
          color: #FFFFFF;
          span{
            margin-left: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .nav{
    width: 100%;
    height: 60px;
    background: #FFFFFF;
    box-shadow: 0px 2px 5px 0px rgba(216, 216, 216, 0.41);
    .nav-list{
      width: 1120px;
      height: 100%;
      font-size: 18px;
      font-weight: 800;
      color: #585858;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      span{
        line-height: 60px;
        padding: 0 14px;
        cursor: pointer;
        &.active{
          color: #FF6E71;
          border-bottom: 4px solid #FF6E71;
        }
      }
    }
  }
  .isFixed{
  position:fixed;
  top:0;
  left:0;
  z-index:10;
  }
</style>



// WEBPACK FOOTER //
// src/components/PicHeader.vue